<template>
  <div>
    <div class="mx-5 py-5 d-flex justify-space-between">
      <h5>Add New User</h5>
    </div>

    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
        <!-- <div class="d-flex justify-center">
          <v-card style="padding: 1%; background-color: rgb(246, 248, 252);" flat color="transparent">
            <userimageuploader-component 
              :img="User.ProfileImage"
              @setImage="SetImage"
            />
          </v-card>
        </div> -->

        <v-container class="mt-4">
          <v-text-field
            v-model="User.FirstName"
            label="First name *"
            :error-messages="
              getErrorMessage('FirstName', 'FirstName')
            "
          ></v-text-field>
          <v-text-field
            v-model="User.LastName"
            label="Last name *"
            :error-messages="
              getErrorMessage('LastName', 'LastName')
            "
          ></v-text-field>
          <v-select
            v-model="User.membership"
            label="Member Level *"
            attach
            item-text="text"
            item-value="id"
            :items="MemberShipLevelArray"
            :error-messages="
              getErrorMessage('membership', 'membership')
            "
          ></v-select>
          <v-select
            v-model="User.Language"
            label="Language *"
            attach
            :items="languageArray"
            :error-messages="
              getErrorMessage('Language', 'Language')
            "
          ></v-select>
          <v-text-field
            v-model="User.Email"
            label="Email address *"
            autocomplete="off"
            :error-messages="
              getErrorMessage('Email', 'Email')
            "
          ></v-text-field>
          <v-text-field
            v-model="User.Phone"
            label="Phone number *"
            maxlength="17"
            minlength="7"
            :error-messages="
              getErrorMessage('Phone', 'Phone')
            "
          ></v-text-field>
          <v-select
            v-model="User.Country"
            :items="countryList"
            label="Country *"
            class="pt-3"
            :error-messages="
              getErrorMessage('Country', 'Country')
            "
          >
          </v-select>
          <v-text-field
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            v-model="User.Password"
            label="Password *"
            autocomplete="new-password"
            :error-messages="
              getErrorMessage('Password', 'Password')
            "
          ></v-text-field>
        </v-container>
      </v-form>
      <div class="d-flex justify-end mt-3">
        <v-btn
          color="#C4C4C4"
          class="white--text py-5 px-8 mb-6"
          depressed
          @click="close()"
          ><span class="text_style">Cancel</span>
        </v-btn>
        <v-btn
          color="primary"
          class="white--text py-5 px-8 ml-4"
          depressed
          :disabled="btnloader"
          @click="save()"
          ><span v-if="btnloader != true"> Save</span>
          <v-progress-circular
            indeterminate
            size="20"
            v-else
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        ></v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
// import UserimageuploaderComponent from "./userimageuploader.component.vue";
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { required, email,
  // alpha,
  // numeric,
  minLength,
  maxLength, } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// const alphaWithSpaces = (value) => {
//   if (!value) return true;
//   return /^[A-Za-z\s]+$/.test(value);
// };
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+$/.test(value);
  // to allow spaces, special char, latin char. Japanese characters (Kanji, Hiragana and Katakana scripts)
};
const phoneWithSpecialChars = (value) => {
  if (!value) return true;
  return /^[0-9+\-\s()]+$/.test(value);
};
export default {
  mixins: [validationMixin],
  name: "editteamcomponent",
  components: {
    // UserimageuploaderComponent,
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  validations: {
    User: {
      FirstName: { required, alpha: alphaWithSpacesAndSpecialChars },
      LastName: { required, alpha: alphaWithSpacesAndSpecialChars },
      Email: { required, email },
      Phone: { required, numeric:phoneWithSpecialChars, minLength: minLength(7),
        maxLength: maxLength(17), },
      Country: {
        required,
      },
      Password: {
        required, minLength: minLength(8),
      },
      Language: {
        required,
      },
      membership: {
        required,
      },
    },
  },
  data() {
    return {
      show2: false,
      MemberShipLevelArray: [{ text: "Starter - $0", id: 1, amount: 0 }],
      languageArray: ["English", "Japanese", "German", "Portuguese"],
      btnloader: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      User: {
        Language: null,
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: null,
        Password: null,
        membership: null,
        ProfileImageFile: "",
        WebpageURL: "",
        Specializations: "",
        Country: "",
        Bio: "",
        IntroDescription: "",
        AccountType: 1,
      },
      valid: false,
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      memberlevel: "",
      streetaddress1: "",
      streetaddress2: "",
      countryList: [
          "United States",
          "Afghanistan",
          "Albania",
          "Algeria",
          "American Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarctica",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbaijan",
          "Bahamas (the)",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivia (Plurinational State of)",
          "Bonaire, Sint Eustatius and Saba",
          "Bosnia and Herzegovina",
          "Botswana",
          "Bouvet Island",
          "Brazil",
          "British Indian Ocean Territory (the)",
          "Brunei Darussalam",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cabo Verde",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Cayman Islands (the)",
          "Central African Republic (the)",
          "Chad",
          "Chile",
          "China",
          "Christmas Island",
          "Cocos (Keeling) Islands (the)",
          "Colombia",
          "Comoros (the)",
          "Congo (the Democratic Republic of the)",
          "Congo (the)",
          "Cook Islands (the)",
          "Costa Rica",
          "Croatia",
          "Cuba",
          "Curaçao",
          "Cyprus",
          "Czechia",
          "Côte d'Ivoire",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic (the)",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Eswatini",
          "Ethiopia",
          "Falkland Islands (the) [Malvinas]",
          "Faroe Islands (the)",
          "Fiji",
          "Finland",
          "France",
          "French Guiana",
          "French Polynesia",
          "French Southern Territories (the)",
          "Gabon",
          "Gambia (the)",
          "Georgia",
          "Germany",
          "Ghana",
          "Gibraltar",
          "Greece",
          "Greenland",
          "Grenada",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard Island and McDonald Islands",
          "Holy See (the)",
          "Honduras",
          "Hong Kong",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran (Islamic Republic of)",
          "Iraq",
          "Ireland",
          "Isle of Man",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jersey",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea (the Democratic People's Republic of)",
          "Korea (the Republic of)",
          "Kuwait",
          "Kyrgyzstan",
          "Lao People's Democratic Republic (the)",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Macao",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands (the)",
          "Martinique",
          "Mauritania",
          "Mauritius",
          "Mayotte",
          "Mexico",
          "Micronesia (Federated States of)",
          "Moldova (the Republic of)",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Morocco",
          "Mozambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Caledonia",
          "New Zealand",
          "Nicaragua",
          "Niger (the)",
          "Nigeria",
          "Niue",
          "Norfolk Island",
          "Northern Mariana Islands (the)",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Palestine, State of",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Pitcairn",
          "Poland",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Republic of North Macedonia",
          "Romania",
          "Russian Federation (the)",
          "Rwanda",
          "Réunion",
          "Saint Barthélemy",
          "Saint Helena, Ascension and Tristan da Cunha",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Martin (French part)",
          "Saint Pierre and Miquelon",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Sint Maarten (Dutch part)",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "South Georgia and the South Sandwich Islands",
          "South Sudan",
          "Spain",
          "Sri Lanka",
          "Sudan (the)",
          "Suriname",
          "Svalbard and Jan Mayen",
          "Sweden",
          "Switzerland",
          "Syrian Arab Republic",
          "Taiwan",
          "Tajikistan",
          "Tanzania, United Republic of",
          "Thailand",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Turks and Caicos Islands (the)",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates (the)",
          "United Kingdom",
          "Uruguay",
          "USA Minor Outlying Islands",
          "Uzbekistan",
          "Vanuatu",
          "Venezuela (Bolivarian Republic of)",
          "Viet Nam",
          "Virgin Islands (British)",
          "Virgin Islands (U.S.)",
          "Wallis and Futuna",
          "Western Sahara",
          "Yemen",
          "Zambia",
          "Zimbabwe",
          "Åland Islands",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  methods: {
    getErrorMessage(fieldName) {
      const errorMessages = {
        FirstName: {
          required: "First Name is required",
          alpha: "First Name only contains alphabetic characters.",
        },
        LastName: {
          required: "Last Name is required",
          alpha: "Last Name only contains alphabetic characters.",
        },
        Email: {
          required: "Email is required",
          email: "Invalid email address.",
        },
        Phone: {
          required: "Phone number is required",
          numeric: "Phone number should be only numeric characters",
          minLength: "Phone number should be minimum of 7 digits",
          maxLength: "Phone number should be maximum of 12 digits",
        },
        Country:{
          required:"Country is required",
        },
        Password: {
          required: "Password is required",
          minLength: "Password should be a minimum of 8 characters.",
        },
        Language:{
          required: "Language is required",
        },
        membership:{
          required: "Membership is required",
        },
        
      };
      const errorField = this.$v.User[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      return errors.length ? errors[0] : null;
    },
    SetImage(file) {
      console.log(file);
      this.User.ProfileImageFile = file;
    },
    close() {
      this.$emit("close");
      this.$v.$reset();
      this.User = {
        Language: null,
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: null,
        Password: null,
        membership: null,
        ProfileImageFile: "",
        WebpageURL: "",
        Specializations: "",
        Country: "",
        Bio: "",
        IntroDescription: "",
        AccountType: 1,
      };
    },
    
    save() {
      this.$v.User.$touch();
      if (this.$v.User.$invalid) {
        return;
      }
      this.User.UserName = `${this.User.Email.split("@")[0]}`;
      this.formData = new FormData();
      this.formData.append("ProfileImageFile", this.User.ProfileImageFile);
      this.formData.append("UserName", this.User.UserName);
      this.formData.append("FirstName", this.User.FirstName);
      this.formData.append("LastName", this.User.LastName);
      this.formData.append("Email", this.User.Email);
      this.formData.append("Phone", this.User.Phone);
      this.formData.append("Password", this.User.Password);
      this.formData.append("Language", this.User.Language);
      this.formData.append("WebpageURL", this.User.WebpageURL);
      this.formData.append("Specializations", this.User.Specializations);
      this.formData.append("Country", this.User.Country);
      this.formData.append("MembershipId", this.User.membership);
      this.formData.append("Bio", this.User.Bio);
      this.formData.append("IntroDescription", this.User.IntroDescription);
      this.formData.append("LoginAction", "signup");
      this.formData.append("SubscribeNewsLetter", true);
      this.formData.append("AcceptTermCondittions", true);
      this.formData.append("AccountType", this.User.AccountType.toString());
      this.formData.append("isAdminCreatedUser", true);
      this.btnloader = true;
      this.$store.dispatch("SignupUser", this.formData).then(() => {
        this.btnloader = false;
        this.close();
        this.$swal.fire({
          // toast: true,
          // position: "top-end",
          icon: "success",
          title: "New User Added Successfully",
          showConfirmButton: false,
          timer: 3000,
        });
        const obj = {
          page: 1,
          pagesize: "10",
          search: "",
          filters: [],
        };
        this.$store.dispatch("GetAllUser", obj);
      }).catch(() => {
        this.btnloader = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Email Already Exist",
          showConfirmButton: false,
          timer: 3000,
        });
      });
      // setTimeout(() => {
      //   this.btnloader = false;
      // }, 100);
      // setTimeout(() => {
      //   this.close();
      //   this.btnloader = false;
      //   this.$swal.fire({
      //       toast: true,
      //       position: "top-end",
      //       icon: "success",
      //       title: "User Added Successfully",
      //       showConfirmButton: false,
      //       timer: 1500,
      //     });
      //   this.snackbar = true;
      // }, 2000);
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
</style>
